"use client";

import { useState } from "react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const categories = ["All", "Branding", "Web Design", "Photography", "Print"];
const projects = [{
  id: 1,
  title: "Luxury Brand Identity",
  category: "Branding",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/luxury_brand_identity_portfolio.png",
  height: "h-80"
}, {
  id: 2,
  title: "Modern Architecture Site",
  category: "Web Design",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/modern_architecture_website.png",
  height: "h-96"
}, {
  id: 3,
  title: "Editorial Fashion Shoot",
  category: "Photography",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/editorial_fashion_photography.png",
  height: "h-72"
}, {
  id: 4,
  title: "Corporate Stationery Set",
  category: "Print",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/corporate_stationery_design.png",
  height: "h-64"
}, {
  id: 5,
  title: "Artisan Coffee Branding",
  category: "Branding",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/artisan_coffee_brand.png",
  height: "h-88"
}, {
  id: 6,
  title: "E-commerce Platform",
  category: "Web Design",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/ecommerce_platform_design.png",
  height: "h-80"
}, {
  id: 7,
  title: "Product Photography",
  category: "Photography",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/product_photography_studio.png",
  height: "h-72"
}, {
  id: 8,
  title: "Magazine Layout Design",
  category: "Print",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/magazine_layout_design.png",
  height: "h-96"
}, {
  id: 9,
  title: "Tech Startup Branding",
  category: "Branding",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/tech_startup_branding.png",
  height: "h-64"
}, {
  id: 10,
  title: "Restaurant Website",
  category: "Web Design",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/restaurant_website_design.png",
  height: "h-80"
}, {
  id: 11,
  title: "Portrait Photography",
  category: "Photography",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/portrait_photography_session.png",
  height: "h-88"
}, {
  id: 12,
  title: "Poster Design Series",
  category: "Print",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/poster_design_series.png",
  height: "h-72"
}];
function ProjectCard({
  project,
  index
}: {
  project: typeof projects[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-200 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`} style={{
    transitionDelay: `${index % 3 * 50}ms`
  }}>
      <Card className="group overflow-hidden border-0 shadow-soft hover:shadow-medium hover:-translate-y-0.5 hover:scale-[1.02] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] cursor-pointer">
        <div className={`relative ${project.height} overflow-hidden`}>
          <img src={project.image} alt={project.title} className="h-full w-full object-cover transition-transform duration-[var(--duration-medium)] group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-dark-background/80 via-dark-background/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)]" />
        </div>
        <CardContent className="absolute bottom-0 left-0 right-0 p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
          <h3 className="font-display text-lg font-semibold text-foreground mb-1">
            {project.title}
          </h3>
          <p className="text-sm text-muted-dark-background">{project.category}</p>
        </CardContent>
      </Card>
    </div>;
}
export default function Portfolio() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const filteredProjects = selectedCategory === "All" ? projects : projects.filter(project => project.category === selectedCategory);
  return <section id="portfolio" className="py-16 px-6 md:px-12 lg:px-24 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-center mb-12">
          <ToggleGroup type="single" value={selectedCategory} onValueChange={value => {
          if (value) setSelectedCategory(value);
        }} variant="outline" size="lg" className="flex-wrap gap-2">
            {categories.map((category, i) => <ToggleGroupItem key={category} value={category} data-index={i} className="px-6 py-2 font-medium data-[state=on]:bg-accent data-[state=on]:text-foreground hover:bg-accent-hover transition-colors duration-[var(--duration-fast)]">
                {category}
              </ToggleGroupItem>)}
          </ToggleGroup>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredProjects.map((project, index) => <ProjectCard key={project.id} project={project} index={index} />)}
        </div>
      </div>
    </section>;
}